export const selectLink = ({ EULA_reducer = false }) => {
    return EULA_reducer.link || null;
};
